import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'morva-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnChanges {

  @Input() totalPage: number;
  @Input() selectedPage: number;
  @Output() pageChange: EventEmitter<number> = new EventEmitter();

  pages: number[];

  ngOnChanges() {
    this.getShowsPages();
  }

  getShowsPages() {
    if (this.totalPage <= 5) {
      this.pages = this.range(1, this.totalPage);
    } else {
      if (this.selectedPage <= 2) {
        this.pages = this.range(1, 5);
      } else if (
        this.selectedPage === this.totalPage ||
        this.selectedPage === this.totalPage - 1
      ) {
        this.pages = this.range(this.totalPage - 4, this.totalPage);
      } else {
        this.pages = this.range(this.selectedPage - 2, this.selectedPage + 2);
      }
    }
  }

  range(start: number, end: number) {
    var array = [];
    for (var i = start; i <= end; i++) {
      array.push(i);
    }
    return array;
  }

  onPageClick(selectedPage) {
    this.selectedPage = selectedPage;
    this.getShowsPages();
    this.pageChange.emit(this.selectedPage);
  }

  onNextClick() {
    if (this.selectedPage < this.totalPage) {
      this.onPageClick(this.selectedPage + 1);
    }
  }

  onBeforeClick() {
    if (this.selectedPage > 1) {
      this.onPageClick(this.selectedPage - 1);
    }
  }
}
